t = require('views/internal/teacup-with-helpers')('board_header_warnings')

module.exports = t.renderable ({ canDismiss, warning })->
  { key, dismiss } = warning
  t.div '.board-warning', ->
    t.format key
    if canDismiss
      t.span '.js-dismiss-warning.board-warning-close.icon-sm.icon-close', { 'data-dismiss': dismiss }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_header_warnings.coffee